export default __webpack_public_path__ + "static/media/new-icon-appointment.992efe71.svg";